'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _productLabelDownload = require('./product-label-download.html');

var _productLabelDownload2 = _interopRequireDefault(_productLabelDownload);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

exports.default = {
  templateUrl: _productLabelDownload2.default,
  bindings: {
    product: '<',
    labelChanged: '<'
  },
  controller: function () {
    function ProductLabelDownloadComponent(ameLightbox, ProductsService, ToastService) {
      'ngInject';

      _classCallCheck(this, ProductLabelDownloadComponent);

      Object.assign(this, {
        ameLightbox: ameLightbox,
        ProductsService: ProductsService,
        ToastService: ToastService
      });
    }

    _createClass(ProductLabelDownloadComponent, [{
      key: '$onInit',
      value: function $onInit() {
        var _this = this;

        if (this.product.FileLabelName && this.product.ProductId) {
          if (this.product.FileLabelName.endsWith('.pdf')) {
            this.fileType = 'pdf';

            this.ProductsService.getLabel(this.product.ProductId).then(function (r) {
              _this.download = r.data;
            });
          } else {
            this.fileType = 'image';
          }
        }
      }
    }, {
      key: 'previewLabelImage',
      value: function previewLabelImage(productId) {
        var _this2 = this;

        this.ProductsService.getLabelImage(productId).then(function (r) {
          _this2.ameLightbox.show([r.data], {
            buttonClass: 'ng-hide',
            keyboard: false,
            showDots: false
          });
        }).catch(function (error) {
          return _this2.ToastService.showError(error);
        });
      }
    }]);

    return ProductLabelDownloadComponent;
  }()
};


// WEBPACK FOOTER //
// ./components/app/product/information/product-label-download/product-label-download.component.js